import JSZip from "jszip";
import { WavFile } from "@opendaw/lib-dsp";
import { SampleMetaData, SoundfontMetaData } from "@opendaw/studio-adapters";
export var AssetZip;
(function (AssetZip) {
    AssetZip.packSample = async (wavBytes, meta) => {
        const zip = new JSZip();
        zip.file("audio.wav", wavBytes);
        zip.file("meta.json", JSON.stringify(meta));
        return zip.generateAsync({ type: "arraybuffer" });
    };
    AssetZip.unpackSample = async (zipBytes) => {
        const zip = await JSZip.loadAsync(zipBytes);
        const wavBytes = await zip.file("audio.wav").async("arraybuffer");
        const metaJson = await zip.file("meta.json").async("string");
        const audioData = WavFile.decodeFloats(wavBytes);
        const meta = SampleMetaData.parse(JSON.parse(metaJson));
        return [audioData, meta];
    };
    AssetZip.packSoundfont = async (sf2Bytes, meta) => {
        const zip = new JSZip();
        zip.file("soundfont.sf2", sf2Bytes);
        zip.file("meta.json", JSON.stringify(meta));
        return zip.generateAsync({ type: "arraybuffer" });
    };
    AssetZip.unpackSoundfont = async (zipBytes) => {
        const zip = await JSZip.loadAsync(zipBytes);
        const sf2Bytes = await zip.file("soundfont.sf2").async("arraybuffer");
        const metaJson = await zip.file("meta.json").async("string");
        const meta = SoundfontMetaData.parse(JSON.parse(metaJson));
        return [sf2Bytes, meta];
    };
})(AssetZip || (AssetZip = {}));
